function decodeBase64Url(value) {
  const normalized = String(value || "")
    .replace(/-/g, "+")
    .replace(/_/g, "/")
    .padEnd(Math.ceil(String(value || "").length / 4) * 4, "=");

  const binary = window.atob(normalized);
  const bytes = Array.from(binary, (char) =>
    `%${char.charCodeAt(0).toString(16).padStart(2, "0")}`
  ).join("");

  return decodeURIComponent(bytes);
}

export function decodeJwtPayload(token) {
  const tokenValue = String(token || "").trim();
  const segments = tokenValue.split(".");

  if (segments.length < 2) {
    throw new Error("Invalid token format.");
  }

  const payload = decodeBase64Url(segments[1]);
  const parsed = JSON.parse(payload);

  if (!parsed || typeof parsed !== "object") {
    throw new Error("Invalid token payload.");
  }

  return parsed;
}

export function extractTokenRoles(token) {
  const payload = decodeJwtPayload(token);
  return Array.isArray(payload.roles)
    ? payload.roles.map((role) => String(role || "").trim()).filter(Boolean)
    : [];
}

export function extractTokenSubject(token) {
  const payload = decodeJwtPayload(token);
  return String(payload.sub || "").trim();
}

export function hasRequiredRole(token, requiredRole) {
  return extractTokenRoles(token).includes(requiredRole);
}
